import { render, staticRenderFns } from "./templateTable.vue?vue&type=template&id=2eddd61a"
import script from "./templateTable.vue?vue&type=script&lang=js"
export * from "./templateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports